<template>
    <div class="page-header">
		<img class="header-logo hover-dom" src="@/assets/img/logo_TM.png" alt="" @click="handleGo('https://ff.web.sdo.com/', true)">
		<img class="header-logo-tm" src="@/assets/img/logo_TM.fanfest.png" alt="">
		<img class="header-back hover-dom" src="@/assets/img/icon_Home.png" alt="" @click="handleGo('https://actff1.web.sdo.com/project/20240202favn6b6tv8a8s8f8e8s8t/index.html#/index')">
	</div>
</template>

<script>
import {
} from 'vant';

export default {
	name: 'Header',
	props: {},
	components: {},
	data() {
		return {
			picCode: '',
			captchaInfo: {},
		};
	},
	created() {
	},
	mounted() {
	},
	methods: {
		handleGo(url, newTarget) {
			const ua = window.navigator.userAgent;

			if (newTarget || (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0)) {
				window.open(url);
			} else {
				window.location.href = url;
			}
		},
	},
	watch: {
	},
};
</script>

<style scoped lang='scss'>
.page-header {
	display: flex;
	align-items: center;
	width: 100vw;
	background-color: #389566;
}

.app-pc {
	.page-header {
		padding: 0 20px;
		box-sizing: border-box;
		height: 90px;
		.header-logo {
			height: 50px;
		}
		.header-logo-tm {
			margin-left: 10px;
			height: 36px;
		}
		.header-back {
			margin-left: auto;
			height: 63px;
		}
	}
}
.app-mobile {
	.page-header {
		padding: 0 6px;
		box-sizing: border-box;
		height: 36px;
		.header-logo {
			height: 19px;
		}
		.header-logo-tm {
			margin-left: 6px;
			height: 19px;
		}
		.header-back {
			margin-left: auto;
			height: 25px;
		}
	}
}
</style>
